import * as React from "react";
const SvgLinkAlt = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8529_31192)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.33276 7.99971C9.33276 11.6664 5.6661 11.333 4.6661 11.333C3.6661 11.333 1.33276 10.6664 1.33276 7.99971C1.33276 5.33305 3.77721 4.66638 4.6661 4.66638H4.99943M6.6661 8.00761C6.6661 4.34094 10.3328 4.67428 11.3328 4.67428C12.3328 4.67428 14.6661 5.34094 14.6661 8.00761C14.6661 10.6743 12.2217 11.3409 11.3328 11.3409L10.9994 11.333",
      stroke: "#004B9F",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8529_31192" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" })))
);
export default SvgLinkAlt;
